import React from "react";
import { LiferayProps } from "../..";
import { useState, useEffect } from "react";
import ButtonFormMf from "../../commons/Button/ButtonFormMf";
import InputFormMf from "../../commons/Input/InputFormMf";
import SelectFormMf from "../../commons/Select/SelectFormMf";
import { ReactComponent as FirstPage } from "../../assets/icons/first_page.svg";
import { ReactComponent as Next } from "../../assets/icons/next.svg";
import { ReactComponent as Prev } from "../../assets/icons/previous.svg";
import { ReactComponent as LastPage } from "../../assets/icons/last_page.svg";
import { CONSTANTS } from "../../commons/Constants/Constants";
import { classNames } from "primereact/utils";
import { Paginator } from 'primereact/paginator';
import "../pagination/Paginator.scss";
import "./FormExamens.scss";
import { useFormContext } from "../context/FormContext";

interface Results {
  id: number;
  codeCups: string;
  testName: string;
  sampleType: string;
  laboratoryCode: string;
  labName: string;
  resultDeliveryTime: string;
}

interface TitleCustomize {
  hideField: boolean;
  text: string;
  value: string;
}

declare global {
  interface Window {
    Liferay: any; // Puedes definir 'any' o crear una estructura más específica si conoces las propiedades
  }
}

const FormExamens: React.FC<LiferayProps> = ({ properties }) => {
  const {
    visible,
    setVisible,
    handleCodLaboratory,
    handleName,
    handleCupsCode,
    handleOption,
    setStateCompany,
    handleKeyDown,
    dataCards,
    selectedOption,
    first,
    rows,
    cupsCode,
    codLaboratory,
    nameValue,
    handleButtonClickCards,
    onPageChange,
    dataTypeDocument,
    fetchDataTitle,
    fetchData,
    liferayId,
    setLiferayId,
    typeOfSearch,
    setTypeOfSearch,
    dataTitles,
    sampleNames,
    cupsCodeData,
    codeLaboratoryData,
    setUserId,
    tokenMw
  } = useFormContext();

  const [backgroundColor, setBackgroundColor] = useState('');
  const [backgroundCustomize, setBackGroundCustomize] = useState('')
  const [customMessage, setCustomMessage] = useState('');
  const [urlParams, setUrlParams] = useState('');

  useEffect(() => {
    if (properties.backgroundCustomizeButtom !== null) {
      setBackGroundCustomize(properties.backgroundCustomizeButtom);
    }
    if (properties.customizeMessage !== null){
      setCustomMessage(properties.customizeMessage)
    }
  }, [properties.backgroundCustomizeButtom, properties.customizeMessage]);
   
  const liferayGroup = window?.Liferay?.ThemeDisplay?.getSiteGroupId();
  const relativeUrl = window?.Liferay?.ThemeDisplay?.getLayoutRelativeURL();
  
  useEffect(() => {
    const themeDisplay = window?.Liferay?.ThemeDisplay; // Validación para evitar errores si no existe
  
    if (themeDisplay) {
      const relativeURL = themeDisplay.getLayoutRelativeURL();
  
      if (
        relativeURL === '/web/personas/servicios' ||
        relativeURL === '/web/personas/preparacion-de-examenes' ||
        relativeURL === '/web/personas/laboratorio-clinico' ||
        relativeURL === '/web/personas/unidad-de-genomica' ||
        relativeURL === '/web/personas/laboratorio-de-patologia' ||
        relativeURL === '/web/personas/banco-de-sangre-y-servicios-de-gestion-pre-transfusional' ||
        relativeURL === '/web/empresas/servicios' ||
        relativeURL === '/web/empresas/preparacion-de-examenes' ||
        relativeURL === '/web/empresas/laboratorio-clínico' ||
        relativeURL === '/web/empresas/unidad-de-genómica' ||
        relativeURL === '/web/empresas/laboratorio-de-patología' ||
        relativeURL === '/web/empresas/banco-de-sangre-y-servicios-de-gestión-pre-transfusional' ||
        relativeURL === '/web/empresas/paquetes-para-laboratorios'
      ) {
        sessionStorage.removeItem('cardData');
      }
    } else {
      console.warn("Liferay.ThemeDisplay is not available");
    }
  }, [relativeUrl, liferayGroup]);
  
  useEffect(() => {
    const themeDisplay = window?.Liferay?.ThemeDisplay; // Validación para evitar errores si no existe
  
    if (themeDisplay) {
      const layoutURL = themeDisplay.getLayoutRelativeControlPanelURL();
      setUserId(themeDisplay.getUserId());
      setLiferayId(themeDisplay.getSiteGroupId());
  
      if (
        layoutURL.includes("/personas/") ||
        layoutURL === '/group/personas/~/control_panel/manage'
      ) {
        setBackgroundColor("#008767");
        setUrlParams('/web/personas/buscador-de-examenes-detalle');
        setStateCompany(true);
        setTypeOfSearch('person');
        console.log('entre a personas')
      } else if (
        layoutURL.includes("/empresas/") ||
        layoutURL === '/group/empresas/~/control_panel/manage'
      ) {
        setBackgroundColor("#0071A3");
        setUrlParams('/web/empresas/buscador-de-examenes-detalle');
        setStateCompany(false);
        setTypeOfSearch('company');
        console.log('entre a empresa')
      }
    } else {
      console.warn("Liferay.ThemeDisplay is not available");
    }
  }, []);   

  const truncatedDataTypeDocument = dataTypeDocument.map((item: any) => ({
    ...item,
    text: item.text.length > 30 ? item.text.substring(0, 30) + '...' : item.text
  })); 

  const nameExists = sampleNames.find((name: string) => name === nameValue);

  return (
    <>
      <div className="mf-k-form-main-container">
        <section className="mf-k-form-container">
          { typeOfSearch === 'person' &&
            (<h3 className="mf-k-form-title">
            Consulte su exámen a realizar
          </h3>)
          }
          { typeOfSearch === 'company' && (
            <h3 className="mf-k-form-title">
              Consulta nuestro portafolio de servicios
            </h3>
          )
          }
          <p className="mf-k-form-description">
          A continuación podrás seleccionar el servicio de tu interés.
          </p>

          <div className="mf-k-form-inputs" style={{backgroundColor: relativeUrl.includes('/empresas') ? '#0071A3' : '#008767'}} >
              <section className="l-c-bg-title">
                <div className="l-c-bg-title__triangle"
                    style={{borderTopColor: 'white', backgroundColor: 'white'}}></div>
                <div className="l-c-bg-title__triangle-inside" style={{backgroundColor: 'white'}}>
                </div>
            </section>
            {/* <div className="mf-k-form-triangle"></div> */}
            <div className="mf-k-form-inputs-container">
              <InputFormMf
                placeholderCustomize={""}
                styleCustomize={"k-input-cod-cups"}
                maxLenghtCustomize={7}
                typeInput={"text"}
                idInput={"searchInput"}
                labelCustomize={dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CODIGO_CUPS')?.text || 'Código de CUPS'}
                iconCustomize={""}
                altIcon={""}
                onChange={handleCupsCode}
                dataListId="list-cupscode"
              />
              {/* Datalist fuera del componente para conectar con el input */}
              <datalist id="list-cupscode">
                  {cupsCodeData.map((name:any, index: number) => (
                    <option key={index} value={name.text} />
                  ))}
                </datalist>
              {typeOfSearch === 'company' && (
                <InputFormMf
                  placeholderCustomize={""}
                  styleCustomize={"k-input-cod-laboratory"}
                  maxLenghtCustomize={4}
                  typeInput={"text"}
                  idInput={"filterInput"}
                  labelCustomize={dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_CODIGO_LABORATORIO')?.text || 'Código de laboratorio'}
                  iconCustomize={""}
                  altIcon={""}
                  onChange={handleCodLaboratory}
                  dataListId={"list-laboratory"}
                  test-id="input-cod-laboratorio"
                />
              )}
              <datalist id="list-laboratory">
                  {codeLaboratoryData.map((name:any, index: number) => (
                    <option key={index} value={name.text} />
                  ))}
                </datalist>
              <InputFormMf
                placeholderCustomize={""}
                styleCustomize={"k-input-name"}
                maxLenghtCustomize={30}
                typeInput={"text"}
                idInput={"nameInput"}
                labelCustomize={dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_NOMBRE_PRUEBA')?.text || 'Nombre de la prueba'}
                iconCustomize={""}
                altIcon={""}
                onChange={handleName}
                dataListId={'list-sample'}
              />
              {/* Datalist fuera del componente para conectar con el input */}
                <datalist id="list-sample">
                  {sampleNames.map((name:any, index: number) => (
                    <option key={index} value={name.text} />
                  ))}
                </datalist>
            </div>
            <SelectFormMf
              styleCustomize={"k-select--selected"}
              valueInserted={selectedOption}
              onChange={handleOption}
              idSelect={"optionSelect"}
              labelCustomize={dataTitles.find((title: TitleCustomize) => title.value === 'TITULO_TIPO_MUESTRA')?.text || 'Tipo de muestra'}
              iconCustomize={""}
              altIcon={""}
              optionsSelect={truncatedDataTypeDocument}
              placeholderSelect={"Selecciona..."}
            />
            <ButtonFormMf 
              txtButton={CONSTANTS.FORM.BUTTON_FORM}
              styleCustomize={ nameValue.length > 1 || cupsCode.length > 1  || codLaboratory.length > 1 || selectedOption.length > 1 ? "k-button-primary move-bottom" :  "k-button-primary--disabled move-bottom"}
              iconCustomize={""}
              disabledButton={nameValue.length > 1 || cupsCode.length > 1  || codLaboratory.length > 1 || selectedOption.length > 1 ? false : true}
              backgroundCustomize=""
              onClick={() => {
                fetchData(tokenMw);
              }}
            />
          </div>

          
          {dataCards !== null && visible === true &&(
            
            <div className="mf-k-cards-container container">
              
              { dataCards.length > 0 &&
                <p className="mf-k-results">
                Mostrando {dataCards.length} resultados{" "}
              </p>
              }
              <div>
              <div className="mf-k-card-list">
                  {dataCards.length > 0 ? (
                    dataCards.slice(first, first + rows).map((item: Results, index: number) => {
                      const truncatedResultDeliveryTime = item.resultDeliveryTime.length > 33 
                        ? item.resultDeliveryTime.slice(0, 33) + '...' 
                        : item.resultDeliveryTime;
                      const truncatedSampleType = item.sampleType.length > 27
                        ? item.sampleType.slice(0, 27)
                        : item.sampleType
                      const truncatedTitle = item.testName.length > 40
                        ? item.testName.slice(0, 40)
                        : item.testName
                      return (
                        <div className="mf-k-card-list__card" key={index}>
                          <div className="mf-k-card-list__cardText">
                            <p className="mf-k-card-list__cardText--title">{truncatedTitle}</p>
                            <p className="mf-k-card-list__cardText--description">Tipo de Muestra: {truncatedSampleType}</p>
                            <p className="mf-k-card-list__cardText--description">
                              Tiempo de entrega de resultados: {truncatedResultDeliveryTime}
                            </p>
                          </div>
                          <ButtonFormMf
                            txtButton={CONSTANTS.FORM.BUTTON_CARDS}
                            styleCustomize={"k-button-primary cards-button"}
                            iconCustomize={""}
                            backgroundCustomize={properties.backgroundCustomizeButtom === null || properties.backgroundCustomizeButtom === '' ? backgroundColor : backgroundCustomize}
                            disabledButton={false}
                            onClick={() => {
                              sessionStorage.setItem('cardData', JSON.stringify(dataCards[index]));
                              window.location.href = urlParams;
                            }}
                          />
                        </div>
                      );
                    })
                  ) : (visible && !nameExists && cupsCode === ""  && codLaboratory === "" && selectedOption === "" ? (
                    
                    <p className="mf-k-no-results" test-id="no-results">
                      {customMessage + " " + nameValue + ", intenta con otra palabra"}
                    </p>
                  )
                  : (
                    <p className="mf-k-no-results" test-id="no-results">
                      No hay resultados para la búsqueda
                    </p>
                    
                  )
                  )}
              </div>

                {dataCards.length > rows && <div className="Paginator">
                  <Paginator
                    first={first}
                    rows={rows}
                    pageLinkSize={4}
                    totalRecords={dataCards.length}
                    rowsPerPageOptions={[2,3,6]}
                    onPageChange={onPageChange}
                    template={{
                      layout:
                        "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLinks LastPageLink",
                      FirstPageLink: (options) => (
                        <FirstPage
                          className="p-paginator-first"
                          onClick={options.onClick}
                        />
                      ),
                      PrevPageLink: (options) => (
                        <Prev className="p-paginator-prev" onClick={options.onClick} />
                      ),
                      NextPageLink: (options) => (
                        <Next className="p-paginator-next" onClick={options.onClick} />
                      ),
                      LastPageLink: (options) => (
                        <LastPage className="p-paginator-last" onClick={options.onClick} />
                      ),
                      PageLinks: (options) => {
                        if (
                          (options.view.startPage === options.page &&
                            options.view.startPage === options.view.endPage &&
                            options.view.startPage === 1) ||
                          (options.view.endPage === options.page &&
                            options.page + 1 !== options.totalPages)
                        ) {
                          const className = classNames(options.className, {
                            "p-disabled": true,
                          });
                          const onClickLastPage = () => onPageChange(options.totalPages);

                          return (
                            <>
                              <span
                                className={className}
                                style={{
                                  userSelect: "none",
                                  background: "none",
                                  color: "black",
                                  margin: "0 -10px 0 -10px",
                                }}
                              >
                                ...
                              </span>
                              <button
                                type="button"
                                className={className}
                                onClick={onClickLastPage}
                              >
                                {options.totalPages}
                              </button>
                            </>
                          );
                        }

                        return (
                          <button
                            type="button"
                            className={options.className}
                            onClick={options.onClick}
                          >
                            {options.page + 1}
                          </button>
                        );
                      },
                    }}
                  />
                </div>}
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};
export default FormExamens;
